import { formulaText } from '@erp/workbooks';
import {
  FormulaReferenceChip,
  FormulaTableReferenceChip,
} from './FormulaReferenceChip';
import { formulaSegments } from './formulaEditorText';
import {
  resolveFormulaField,
  resolveFormulaTable,
  type FormulaFields,
} from './worksheetFormulaFields';

/**
 * A stored Formula shown read-only, with the editor's Reference chips. Copying
 * any of it copies the whole Formula as Excel text.
 */
export function WorksheetFormula({
  expression,
  fields,
}: {
  expression: string;
  fields: FormulaFields;
}) {
  const segments = formulaSegments(expression, fields);
  return (
    <code
      className="inline-flex flex-wrap items-center gap-y-1 font-mono text-xs whitespace-pre-wrap"
      onCopy={(event) => {
        event.clipboardData.setData(
          'text/plain',
          formulaText(expression, fields.tables ?? []),
        );
        event.preventDefault();
      }}
    >
      <span aria-hidden>=</span>
      {segments.map((segment, index) =>
        segment.kind === 'text' ? (
          <span key={index}>{segment.text}</span>
        ) : segment.kind === 'table' ? (
          <FormulaTableReferenceChip
            key={index}
            table={resolveFormulaTable(fields, segment.tableId)}
            column={segment.column}
          />
        ) : (
          <FormulaReferenceChip
            key={index}
            name={segment.name}
            field={resolveFormulaField(fields, segment.name)}
          />
        ),
      )}
    </code>
  );
}
